var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.showPanel}},[_vm._v("Show Menu")]),_vm._v(" "),_c('slideout-panel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }